<template>

  <!-- main image -->
  <div class="product-slider__main-image">
    <a :href="expandedUrl(images[0])" 
       class="MagicZoom" 
       id="productSlider" 
       data-options="lazyZoom: true; zoomPosition: inner; upscale: false;" 
       aria-label="zoom in on product image"
       role="button"
      >
      <img 
          :src="mainUrl(images[0])" 
          :alt="`image 1 of ${images.length}`">
    </a>
  </div>
  
  <!-- thumbnails -->
  <div class="product-slider__thumbnail-container">
    <div ref="tnsContainer">
      <div v-for="(image, index) in images" :key="index">
        <a data-zoom-id="productSlider" 
           :href="expandedUrl(image)" 
           :data-image="mainUrl(image)"
           :aria-label="`go to image ${index + 1}`"
            role="button">
          <img 
              :src="thumbUrl(image)"
              :alt="`image ${index + 1} of ${images.length}`"
              class="product-slider__thumbnail-image" >
        </a>
      </div>
    </div>
  </div>

</template>

<script>
import { tns } from 'tiny-slider'
import '../../../static/vendor/magiczoomplus/magiczoomplus.js'
export default {
  name: 'IntProductSlider',
  components: { tns  },
  mounted() {
    tns({
      container: this.$refs.tnsContainer,
      loop: false,
      items: 1,
      controls: true,
      mouseDrag: true,
      nav: false,
      autoplay: false,
      autoplayButtonOutput: false,
      "autoplayHoverPause": true,
      arrowKeys: true,
      edgePadding: 0,      
      lazyload: false,
      gutter: 10,
      responsive: {
        0: {
          items: 1
        },
        350: {
          items: 2
        },
        440: {
          items: 3
        },
        560: {
          items: 4
        },
        1024: {
          items: 4
        },
        1536: {
          items: 5
        }
      }
    })
  },
  props: {
    images: {
      type: Array,
      required: true
    },   
    maxExpandedWidth: {
      type: Number,
      default: 2000
    },
    imageOptions: {
      type: String,
      default: 'format=webp&quality=80&rmode=boxpad&bgcolor=FFFFFF'
    }
  },
  computed: {
    mainImageWidth() {
      // magic zoom uses urls to know which main image to load, so we need to build urls based on screen width - srcset and sizes won't work
      if (window.innerWidth <= 375) return 120
      if (window.innerWidth <= 768) return 364
      return 740
    },
    mainImageHeight() {
      return Math.ceil(this.mainImageWidth * 2/3)
    }
  },
  methods: {
    expandedUrl(image) {
      
      // image smaller than main image dimensions
      if (image.width < this.mainImageWidth && image.height < this.mainImageHeight) {
        return `${image.url}?width=${this.mainImageWidth}&height=${this.mainImageHeight}&${this.imageOptions}`
      }
      
      let width = image.width < this.maxExpandedWidth ? image.width : this.maxExpandedWidth
      let height = Math.ceil(width * (2/3));
      
      if (height > image.height) {
        height = image.height < this.maxExpandedWidth ? image.height : this.maxExpandedWidth
        width = Math.ceil(height * (3/2));
      }
      
      return `${image.url}?width=${width}&height=${height}&${this.imageOptions}`
    },
    mainUrl(image) {
      return `${image.url}?width=${this.mainImageWidth}&height=${this.mainImageHeight}&${this.imageOptions}`
    },    
    thumbUrl(image) {
      return `${image.url}?width=124&height=124&${this.imageOptions}`
    },
  }
}
</script>

<style scoped>
@import '../../../static/vendor/magiczoomplus/magiczoomplus.css';
@import '../../../static/vendor/tinyslider/tinyslider.css';

.product-slider__main-image {
  display: flex;  
}

.product-slider__thumbnail-container {
  position: relative;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.product-slider__thumbnail-image {
  margin: 0 auto;
}


</style>

<style>
.product-slider__thumbnail-container .tns-item {
  text-align: center;
}

.product-slider__thumbnail-container .tns-controls {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.product-slider__thumbnail-container .tns-controls button {
  background-color: transparent;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  border: none;
  color: transparent!important;
  height: 100%;
  position: absolute;
  top: 0;
  width: 0.6rem;
}

.product-slider__thumbnail-container .tns-controls button:disabled {
  opacity: 0.25;
  cursor: not-allowed;
}

.product-slider__thumbnail-container .tns-controls button[data-controls="prev"] {
  left: 0;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22.512' height='43.61'%3E%3Cpath data-name='Path 29' d='M22.159.354.708 21.805l21.451 21.451' fill='none' stroke='%23646464' stroke-width='2'/%3E%3C/svg%3E");
}

.product-slider__thumbnail-container .tns-controls button[data-controls="next"] {
  right: 0;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22.512' height='43.61'%3E%3Cpath data-name='Path 30' d='m.353 43.256 21.451-21.451L.353.354' fill='none' stroke='%23646464' stroke-width='2'/%3E%3C/svg%3E");
}
</style>